<script>
	import { onMount, onDestroy } from 'svelte';
	import { createEventDispatcher } from 'svelte';
	import mapbox from 'mapbox-gl';
    import BusIcon from './BusIcon.svelte';
	import PopUpMenu from './PopUpMenu.svelte';
	import BusLineMenu from './BusLineMenu.svelte';

    const dispatch = createEventDispatcher();

	export let map;

	function filterObject(obj, predicate) {
	return Object.keys(obj)
		.filter( key => predicate(obj[key]) )
		.reduce( (res, key) => (res[key] = obj[key], res), {} );
	}

	const gtfsRoutesUrl = "https://data.foli.fi/gtfs/v0/routes";
	let allLines = [];
	let selectedLines = [];
	onMount(() => {
		var req = new XMLHttpRequest();
		req.onreadystatechange = function() {
			if (req.readyState == 4 && req.status == 200) {
				var response = JSON.parse(req.responseText);
				allLines = response.map(line => line.route_short_name);
				// This performs a natural sort: 1, 2, 2A, 2B, 2C, 3...
				const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
				allLines.sort(collator.compare);
				selectedLines = allLines;
			}
		}
		req.open("GET", gtfsRoutesUrl, true);
		req.send(null);
	});

	const siriUrl = "https://data.foli.fi/siri/vm";
	let busmarkers = {};
	let buspopups = {};

	function newBus(bus, popup) {
		const el = document.createElement('div');
		const icon = new BusIcon({
			target: el,
			props: {
				lineName: bus.publishedlinename
			}
		});

		return new mapbox.Marker(el)
			.setLngLat([bus.longitude, bus.latitude])
			.setPopup(popup)
			.addTo(map);
	}
	
	const liikennoitsijat = {
//		"2": "TLO",
//		"6": "Jalo Bus",
//		"8": "TuKL",
//		"11": "Savonlinja",
//		"16": "Turkubus",
//		"18": "Muurinen",
//		"20": "Nyholm",
//		"22": "Nobina",
//		"27": "Citybus",
//		"28": "Vesma",
//		"41": "Länsilinjat",
//		"55": "V-S Bussipalvelut",
//		"67": "Vainio",
//		"68": "Päivölä",
//		"69": "Airisto Line",
//        "70": "Explore Saimaa",
//        "80": "Lauran Bussi",
//        "81": "Sa Tilausajot"
	};

	function formatBusID(busID) {
		if (busID.slice(0,-4) in liikennoitsijat) {
			return liikennoitsijat[busID.slice(0,-4)] + ' ' + parseInt(busID.slice(-4));
		} else {
			return busID;
		}
	}

	function generatePopupContents(busID, bus) {
		return '<b>'+bus.publishedlinename+'</b> '+bus.destinationname+'<br />'+
			formatBusID(busID);
	}

	function updateBuses() {
		var req = new XMLHttpRequest();
		req.onreadystatechange = function() { 
			if (req.readyState == 4 && req.status == 200) {
				var response = JSON.parse(req.responseText);
				if (response.status == "OK") {
					//document.getElementById("error").style.visibility = 'hidden';
					var buses = filterObject(response.result.vehicles, v => (v.monitored && selectedLines.includes(v.publishedlinename)));
					for (var busID in busmarkers) {
						if (!(busID in buses)) {
							busmarkers[busID].remove();
							delete busmarkers[busID];
							delete buspopups[busID];
						}
					}
					for (var busID in buses) {
						if (busID in busmarkers) {
							busmarkers[busID].setLngLat([buses[busID].longitude, buses[busID].latitude]);
							buspopups[busID].setHTML(generatePopupContents(busID, buses[busID]));
						} else {
							buspopups[busID] = new mapbox.Popup({ offset: 25 }).setHTML(generatePopupContents(busID, buses[busID]));
							busmarkers[busID] = newBus(buses[busID]).setPopup(buspopups[busID]).addTo(map);
						}
					}
				} else {
					//document.getElementById("error").style.visibility = 'visible';
				}
			}
		}
		req.open("GET", siriUrl, true); // true for asynchronous 
		req.send(null);
	}

	const interval = setInterval(updateBuses, 3000);

	onDestroy(() => clearInterval(interval));

	export let busLineMenuOpen;

	function closeBusLineMenu(event) {
		selectedLines = event.detail.selectedLines;
		updateBuses();
		dispatch('closeBusLineMenu');
	}
</script>

{#if busLineMenuOpen}
<PopUpMenu><BusLineMenu {allLines} on:done={closeBusLineMenu}></BusLineMenu></PopUpMenu>
{/if}
